import React, { useState, useEffect, ChangeEvent, useMemo } from 'react';
import './OrderForm.css';
import { Field, FieldArray } from 'formik';

interface Product {
  id: number;
  title: string;
  price: number;
  quantity: number;
}

interface OrderFormRowsProps {
  products: Product[];
  customerDeliveryPickUp: boolean;
}

function removeLeadingZeros(number: any): number {
  return parseInt(number, 10);
}

function OrderFormRows({ products, customerDeliveryPickUp }: OrderFormRowsProps) {

  const [hasShippingFees, setHasShippingFees] = useState<boolean>(false);

  // if customerDeliveryPickUp is true, then deduct 100kr discount per square meter from each of the products2
  const products2 = useMemo(() => {
    // order products by price from high to low
    return products.map((product: any) => {
      return {
        ...product,
        price: customerDeliveryPickUp ? product.price - 100 : product.price
      }
    })
  }, [products, customerDeliveryPickUp]);

  const totalMeters = useMemo(() => {
    return products2.reduce((total, product, index) => {
      if (product.quantity) {
        return total + product.quantity;
      }
      return total;
    }, 0);
  }, [products2])

  const totalPrice = useMemo(() => {
    let total = products2.reduce((total, product, index) => {
      if (product.price) {
        return total + product.price * product.quantity;
      }
      return total;
    }, 0);
    // if (!customerDeliveryPickUp && totalMeters < 100) {
    //   total += 28000;
    //   setHasShippingFees(true);
    // } else {
    //   setHasShippingFees(false);
    // }
    return total;
  }, [products2, customerDeliveryPickUp, totalMeters]);

  // products2.sort(function (a: any, b: any) {
  //   return parseInt(a.price) < parseInt(b.price) ? 1 : -1;
  // });

  return (
    <div className="pt-4 max-w-[400px]">

      {/* <h2 className="grow font-bold mb-4 text-xl">VÖRUR</h2> */}
      <div className="flex">
        <div className="grow font-bold min-w-[250px]">VÖRUR</div>
        <div className="grow font-bold">FM VERÐ</div>
        <div className="grow font-bold">FM MAGN</div>
        {/* <div className="grow font-bold grow text-right">SAMTALS</div> */}
      </div>

      <FieldArray name="products">
        {({ insert, remove, push }) => (
          products2.map((product: any, index: number) => {
            return (
              <div key={product.id} className="flex">
                <div className="font-bold flex items-center min-w-[250px]" data-ap-product-id={product.id} data-ap-price={product.price}>
                  {product.title}
                </div>
                <div className="flex py-2">
                  <div className="mr-1">
                    <input
                      value={new Intl.NumberFormat('de-DE').format(product.price) + ' Kr.'}
                      disabled
                      autoComplete="off"
                      type="text"
                      className={"text-left text-black border-none"}
                      key={`${product.id}-price`}
                    />
                  </div>
                  <div className="mr-1">
                    <Field
                      min="0"
                      autoComplete="off"
                      type="number"
                      className={`text-right text-black w-8 ${(product.id === 213 || product.id === 214) && products[index] && products[index].quantity % 30 !== 0 ? 'border-red-500' : ''}`}
                      placeholder="Magn"
                      inputMode='numeric'
                      step={product.id === 213 || product.id === 214 ? 30 : 1}
                      name={`products.${index}.quantity`}
                      key={`${product.id}-quantity`}
                    />
                  </div>
                  {/* <div className="grow">
                    <input
                      value={
                        product.quantity ?
                          new Intl.NumberFormat('de-DE').format(product.price * product.quantity) + ' Kr.'
                          :
                          new Intl.NumberFormat('de-DE').format(0) + 'Kr.'
                      }
                      autoComplete="off"
                      type="text"
                      className={"w-full grow text-right text-black"}
                      disabled
                      key={`${product.id}-subtotal`}
                    />
                  </div> */}
                </div>
              </div>
            );
          })
        )}
      </FieldArray>

      {/* {hasShippingFees ? (
        <div className="flex flex-col text-right">
          <div className="font-bold uppercase text-right">
            Akstursgjald
          </div>
          <div className="">
            <input
              className="text-right text-black"
              disabled
              type="text"
              value={
                new Intl.NumberFormat('de-DE').format(23000) + ' Kr.'}
            />
          </div>
        </div>
      ) : null} */}

      <div className="flex flex-col md:flex-row">
        <div className="flex grow order-2 md:order-1">
          <div>
            <img className="max-w-[75px]" src="https://torf.is/wp-content/uploads/2022/11/Visa.png" />
          </div>
          <div>
            <img className="max-w-[75px]" src="https://torf.is/wp-content/uploads/2022/11/Mastercard.png" />
          </div>
        </div>
        <div className="order-1 md:order-2">
          <div className="font-bold uppercase text-right">
            Heildarverð m/vsk.
          </div>
          <div className="">
            <input
              className="text-right text-black"
              disabled
              type="text"
              value={
                new Intl.NumberFormat('de-DE').format(totalPrice) + ' Kr.'}
            />
          </div>
        </div>
      </div>

      <div></div>

      <div className="py-2">
        <span><b>GREIÐSLA VIÐ AFHENDINGU</b></span>
      </div>

    </div>
  );
}

export default OrderFormRows;
